import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
export var useHeaderDesktopContent = function() {
    var isFaireDirectActiveInLoggedOut = useFaireDirectBrand().isFaireDirectActiveInLoggedOut;
    var _useMarketStore = useMarketStore([
        "showNavHeader"
    ]), showMarketNavHeader = _useMarketStore.showNavHeader;
    var isMarketLinkVisible = showMarketNavHeader;
    return {
        isFaireDirectActiveInLoggedOut: isFaireDirectActiveInLoggedOut,
        isMarketLinkVisible: isMarketLinkVisible
    };
};
